<template>
    <div class="has-text-centered">
        <p><b>Medio de pago elegido:</b> {{payment.mpPaymentInformation.getMpPaymentTypeIdDisplay}} {{payment.mpPaymentInformation.mpPaymentMethodId}}</p>
        <p><b>Estado:</b> {{payment.mpPaymentInformation.getStatusDisplay}}</p>
        <a
        v-if="payment.mpPaymentInformation.getMpPaymentTypeIdDisplay.includes('Ticket') && payment.mpPaymentInformation.status == 'pending'"
        class="button is-success is-rounded m-t-10"
        :href="payment.mpPaymentInformation.initPoint">
            Cambiar metodo de pago
        </a>
        
    </div>
</template>

<script>
export default {
    props:{
        payment:{
            type:Object,
            default: new Object({})
        }
    }
}
</script>